export const BASE = process.env.REACT_APP_API_BASE_URL;
export const WEB_BASE = process.env.REACT_APP_BACKEND_URL;
export const SITE_URL = process.env.REACT_APP_SITE_URL || window.location.origin;
export const TOKEN_KEY = "jb_token";

const FILES_MARKER = "/api/files/";
function fixMediaUrls(v) {
  if (typeof v === "string") {
    const i = v.indexOf(FILES_MARKER);
    if (i >= 0 && (i === 0 || v.startsWith("http"))) return `${BASE}${v.slice(i)}`;
    return v;
  }
  if (Array.isArray(v)) return v.map(fixMediaUrls);
  if (v && typeof v === "object") for (const k of Object.keys(v)) v[k] = fixMediaUrls(v[k]);
  return v;
}

export const getToken = () => localStorage.getItem(TOKEN_KEY) || "";
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export function errMsg(e, fallback = "Something went wrong") {
  try {
    const d = JSON.parse(e.message).detail;
    return typeof d === "string" ? d : fallback;
  } catch {
    return e?.message && !e.message.startsWith("HTTP") ? e.message : fallback;
  }
}

async function req(base, path, opts = {}) {
  const headers = { "Content-Type": "application/json", ...opts.headers };
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  const res = await fetch(`${base}/api${path}`, { ...opts, headers });
  if (!res.ok) throw new Error((await res.text()) || `HTTP ${res.status}`);
  return fixMediaUrls(await res.json());
}

const make = (base) => ({
  get: (p) => req(base, p),
  post: (p, body) => req(base, p, { method: "POST", body: JSON.stringify(body || {}) }),
  put: (p, body) => req(base, p, { method: "PUT", body: JSON.stringify(body || {}) }),
  del: (p) => req(base, p, { method: "DELETE" }),
  upload: async (p, form) => {
    const headers = {};
    const token = getToken();
    if (token) headers.Authorization = `Bearer ${token}`;
    const res = await fetch(`${base}/api${p}`, { method: "POST", body: form, headers });
    if (!res.ok) throw new Error((await res.text()) || `HTTP ${res.status}`);
    return fixMediaUrls(await res.json());
  },
});

export const api = make(BASE);
export const webApi = make(WEB_BASE);
export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;
